import { render, staticRenderFns } from "./FieldInfoFrame.vue?vue&type=template&id=77b3b49d&"
import script from "./FieldInfoFrame.vue?vue&type=script&lang=js&"
export * from "./FieldInfoFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports